import React, { useEffect } from "react";
import { services } from "../../../globals";
import { Metadata } from "../../../shared/models/metadata.model";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";
import { mapMetadataToItem } from "../../../shared/utils/source-item.utils";
import { useArrayContext } from "../../../state/ArrayContext";
import { useFileContext } from "../../../state/FileContext";
import { useFilterContext } from "../../../state/FilterContext";
import { useSiteContext } from "../../../state/SiteContext";

export const LinkedBooks = React.memo(function LinkedBooks(): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();
    const { fileState } = useFileContext();
    const { filterState } = useFilterContext();

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            if (!siteState.site?.name || !fileState.path) {
                isMounted && setArray([]);
                return;
            }
            const request: MetadataRequest = { ...filterState };
            delete request.text;
            delete request.customProperties;
            request.systemProperties = { ...(filterState.systemProperties || {}), category: ["book"] };
            request.includes = fileState.path;
            const searchlist: Array<Metadata> = await services.search.search(siteState.site.name, request);
            const deduped = searchlist
                .slice()
                .sort((a, b) => {
                    const pathCompare = a.path.localeCompare(b.path);
                    if (pathCompare !== 0) {
                        return pathCompare;
                    }
                    return (a._id?.str || "").localeCompare(b._id?.str || "");
                })
                .filter((hit, index, arr) => index === 0 || arr[index - 1].path !== hit.path);
            const result = deduped.map((hit, ix) => ({ ...mapMetadataToItem(hit), position: ix + 1 }));
            if (isMounted) {
                setArray(result);
            }
        };
        fetchData();
        return () => { isMounted = false; };
    }, [siteState.site?.name, fileState.path, filterState, setArray]);

    return <></>;
});
